var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.5H3C2.73478 2.5 2.48043 2.60536 2.29289 2.79289C2.10536 2.98043 2 3.23478 2 3.5V7.16875C2 12.7563 6.7375 14.6125 7.6875 14.925C7.89048 14.9918 8.10952 14.9918 8.3125 14.925C9.2625 14.6125 14 12.7563 14 7.16875V3.5C14 3.23478 13.8946 2.98043 13.7071 2.79289C13.5196 2.60536 13.2652 2.5 13 2.5ZM11.0938 6.8625L7.43125 10.3625C7.33656 10.4516 7.21124 10.5008 7.08125 10.5C6.95317 10.5005 6.82991 10.4512 6.7375 10.3625L4.90625 8.6125C4.85546 8.56819 4.81415 8.51406 4.78481 8.45337C4.75547 8.39269 4.7387 8.3267 4.73552 8.25937C4.73233 8.19204 4.74279 8.12476 4.76627 8.06157C4.78975 7.99839 4.82577 7.9406 4.87215 7.89169C4.91853 7.84278 4.97432 7.80375 5.03617 7.77695C5.09802 7.75015 5.16465 7.73614 5.23205 7.73574C5.29946 7.73535 5.36625 7.7486 5.4284 7.77467C5.49056 7.80075 5.5468 7.83913 5.59375 7.8875L7.08125 9.30625L10.4062 6.1375C10.5035 6.05268 10.6297 6.00872 10.7586 6.01482C10.8875 6.02092 11.009 6.0766 11.0978 6.17022C11.1865 6.26384 11.2357 6.38815 11.235 6.51717C11.2342 6.64618 11.1836 6.76992 11.0938 6.8625Z",
    fill: "#92959B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.006b5c5b1cd83d9d2f64d72bbce252a5.svg";
export { ForwardRef as ReactComponent };